import React from "react";
import { useLocation } from "react-router-dom";

import PageSeo from "./PageSeo";
import { toTitleCase } from "./seoUtils";

const PUBLIC_SINGLE_ROUTES = new Set([
  "/",
  "/comingsoon",
  "/brandselfauditkit",
  "/brand-glossary",
  "/press",
  "/privacy-policy",
  "/terms-and-conditions",
  "/shipping-delivery",
  "/cancellation-refund",
]);

function buildRouteTitle(pathname) {
  if (pathname === "/404") {
    return "Page Not Found | Brew Your Brand";
  }

  if (pathname === "/comingsoon") {
    return "Coming Soon | Brew Your Brand";
  }

  if (pathname === "/quick-brand-leads") {
    return "Quick Brand Leads | Brew Your Brand";
  }

  if (pathname.startsWith("/e-magazine/demo/")) {
    return "Demo Blog Preview | Brew Your Brand";
  }

  const pathSegments = pathname.split("/").filter(Boolean);

  if (!pathSegments.length) {
    return null;
  }

  if (pathSegments[0] === "admin" || pathSegments[0] === "client") {
    const scope = pathSegments[0] === "admin" ? "Admin" : "Client";
    const pageName = pathSegments
      .slice(1)
      .filter((segment) => !/^\d+$/.test(segment))
      .map(toTitleCase)
      .join(" ");

    return `${scope}${pageName ? ` ${pageName}` : " Login"} | Brew Your Brand`;
  }

  return "Client Survey | Brew Your Brand";
}

const RouteSeoController = () => {
  const location = useLocation();
  const { pathname } = location;

  const isPrivateRoute =
    pathname === "/admin" ||
    pathname === "/client" ||
    pathname.startsWith("/admin/") ||
    pathname.startsWith("/client/");
  const isDemoRoute = pathname.startsWith("/e-magazine/demo/");
  const isComingSoonRoute = pathname === "/comingsoon";
  const isNotFoundRoute = pathname === "/404";
  const isSingleSegmentRoute =
    /^\/[^/]+$/.test(pathname) && !PUBLIC_SINGLE_ROUTES.has(pathname);
  const shouldNoIndex =
    isPrivateRoute ||
    isDemoRoute ||
    isComingSoonRoute ||
    isNotFoundRoute ||
    isSingleSegmentRoute;

  if (!shouldNoIndex) {
    return null;
  }

  const title = buildRouteTitle(pathname);
  const description = isNotFoundRoute
    ? "This Brew Your Brand page could not be found."
    : isComingSoonRoute
      ? "This Brew Your Brand page is still brewing and is not ready for indexing yet."
      : "This Brew Your Brand route is intended for private, preview, or temporary use.";

  return (
    <PageSeo
      title={title}
      description={description}
      canonical={pathname}
      robots="noindex,nofollow,noarchive"
    />
  );
};

export default RouteSeoController;
